import {graphql} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import HubspotGlobalForm from '@/components/lead-form/global'
import type {HubspotFormSliceFragment, HubspotGlobalFormFragment} from '@/graphql-types'
import Image from '@helios/shared/components/image'
import {BackgroundWrapper, Section, Layout} from '@helios/shared/styles/grid'
import {LifecycleStages} from '@helios/shared/types/marketing-campaigns'

enum HubspotFormTypename {
    Global = 'PrismicHubspotGlobalForm',
}

type HubspotFormType = HubspotFormSliceFragment['primary']['form']['document']['__typename']

export const HubspotFormSlice = ({slice}: {slice: HubspotFormSliceFragment}) => {
    const content = slice.primary

    const hubspotForm = (type: HubspotFormType) => {
        switch (type) {
            case HubspotFormTypename.Global:
                return (
                    <HubspotGlobalForm
                        content={content.form.document.data as HubspotGlobalFormFragment['data']}
                        hubspotProperties={{
                            lifecyclestage: LifecycleStages.Lead,
                            campaign__updating_: 'global_waiting_list',
                        }}
                    />
                )
            default:
                throw new Error('No selected form')
        }
    }

    return (
        <BackgroundWrapper color="muted">
            <Section>
                <Layout variant="two-asymmetrical" alignItems="center" mirrored={content.inverse}>
                    <FeaturedImage image={content.featured_image} width={600} />
                    {hubspotForm(content.form.document.__typename)}
                </Layout>
            </Section>
        </BackgroundWrapper>
    )
}

const FeaturedImage = styled(Image)`
    width: 100%;
`

export const hubspotFormSliceFragment = graphql`
    fragment HubspotFormSlice on PrismicSlicePageDataBodyHubspotForm {
        __typename
        primary {
            featured_image {
                alt
                copyright
                url
                dimensions {
                    height
                    width
                }
            }
            inverse
            form {
                document {
                    ...HubspotGlobalForm
                }
            }
        }
    }
`
